export function SessionParser(session_type, service_data) {
    if (session_type === 'algoserver_exec') {
        return ParseAlgoserverExec(service_data)
    } else if (session_type === 'ase') {
        return ParseASE(service_data)
    }
    return []
}

function ParseASE(service_data) {
    let session_data = []
    if (service_data && service_data.custom_data && service_data.custom_data.spreads) {
        let instance_id = service_data.custom_data.instance_id
        service_data.custom_data.spreads.forEach(spread_order => {
            const user_id = spread_order.user_id || ''
            spread_order.order_ids.forEach(order_id => {
                const source = order_id.info.split(",")[1].replace("Source=", "") || ''
                const account = order_id.info.split(",")[0].replace("Account=", "") || ''
                session_data.push({
                    user_id: user_id,
                    account: account,
                    source: source,
                    instance_id: instance_id || '',
                    order_id: order_id.order_id || ''
                })
            })
        })
    }
    return session_data
}

function ParseAlgoserverExec(service_data) {
    let session_data = []
    if (service_data && service_data.custom_data && service_data.custom_data.jobs) {
        let instance_id = service_data.custom_data.instance_id || ''
        service_data.custom_data.jobs.forEach(algojob => {
            algojob.users.forEach(userjob => {
                let each_job = {
                    job_process_id: algojob.process_id || '',
                    instance_id: instance_id,
                    user_id: userjob.user_id,
                    user_name: '',
                    orders: 0
                }

                let status = userjob.status || '';
                each_job.user_name = status.split("]")[0].substring(1);
                each_job.orders = parseInt(status.split("]").slice(-1)[0].split("order")[0].trim(), 10);

                session_data.push(each_job)
            })
        })
    }
    return session_data
}